import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1 style={styles.h1}>Политика конфиденциальности — Виртуальная АТС V-office</h1>
        <p style={styles.updated}>Дата последнего обновления: 26 мая 2024 г.</p>

        <p style={styles.p}>
          Настоящая Политика конфиденциальности описывает, как приложение{" "}
          <strong>Виртуальная АТС V-office</strong> собирает, использует, хранит и защищает
          информацию Пользователей.
        </p>
        <p style={styles.p}>
          Используя приложение <strong>Виртуальная АТС V-office</strong>, Вы соглашаетесь с
          условиями настоящей Политики конфиденциальности. Если Вы не согласны с
          её условиями, пожалуйста, прекратите использование приложения.
        </p>

        <h2 style={styles.h2}>1. Толкование и определения</h2>

        <h3 style={styles.h3}>Толкование</h3>
        <p style={styles.p}>
          Слова, начинающиеся с заглавной буквы, имеют значения, определённые
          ниже. Эти определения применяются как в единственном, так и во
          множественном числе.
        </p>

        <h3 style={styles.h3}>Определения</h3>
        <p style={styles.p}>
          <strong>Приложение</strong> — программное обеспечение{" "}
          <strong>Виртуальная АТС V-office</strong>, предоставляемое Компанией.
        </p>
        <p style={styles.p}>
          <strong>Компания</strong> — <strong>IT-SPARK LLC</strong>, Армения,
          0078, г. Ереван, ул. Алабяна, д. 65/5, 1-й этаж.
        </p>
        <p style={styles.p}>
          <strong>Персональные данные</strong> — любая информация, относящаяся к
          идентифицированному или идентифицируемому физическому лицу.
        </p>
        <p style={styles.p}>
          <strong>Данные использования</strong> — данные, собираемые
          автоматически при использовании Приложения.
        </p>
        <p style={styles.p}>
          <strong>Устройство</strong> — любое устройство, с которого возможен
          доступ к Приложению, включая компьютер, мобильный телефон или
          планшет.
        </p>
        <p style={styles.p}>
          <strong>Пользователь / Вы</strong> — физическое или юридическое лицо,
          использующее Приложение.
        </p>
        <p style={styles.p}>
          <strong>Сторонние сервисы</strong> — внешние сервисы, платформы и
          системы, используемые в работе Приложения, включая Bitrix24 и другие
          интеграции.
        </p>

        <h2 style={styles.h2}>2. Какие данные мы можем собирать</h2>

        <h3 style={styles.h3}>2.1. Персональные данные</h3>
        <p style={styles.p}>
          При использовании Приложения Компания может запрашивать или получать
          следующие данные:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>имя и фамилию Пользователя;</li>
          <li style={styles.li}>адрес электронной почты;</li>
          <li style={styles.li}>номер телефона;</li>
          <li style={styles.li}>
            данные, связанные с учётной записью и настройками интеграции;
          </li>
          <li style={styles.li}>
            иные данные, необходимые для корректной работы функционала
            телефонии и интеграции.
          </li>
        </ul>

        <h3 style={styles.h3}>2.2. Данные использования</h3>
        <p style={styles.p}>
          Данные использования могут собираться автоматически при использовании
          Приложения. Они могут включать:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>IP-адрес;</li>
          <li style={styles.li}>тип и версию браузера;</li>
          <li style={styles.li}>тип устройства и операционной системы;</li>
          <li style={styles.li}>даты и время использования Приложения;</li>
          <li style={styles.li}>технические журналы и системные логи;</li>
          <li style={styles.li}>
            данные об ошибках, сбоях и диагностическая информация.
          </li>
        </ul>

        <h3 style={styles.h3}>2.3. Данные телефонии и интеграции</h3>
        <p style={styles.p}>
          В связи со спецификой работы Виртуальная АТС V-office, Приложение может обрабатывать
          данные, связанные с телефонией и CRM-интеграциями, включая:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>номер телефона абонента;</li>
          <li style={styles.li}>номер внутренней линии или сотрудника;</li>
          <li style={styles.li}>дату и время звонка;</li>
          <li style={styles.li}>длительность звонка;</li>
          <li style={styles.li}>
            статус и направление звонка (входящий, исходящий, пропущенный и т.д.);
          </li>
          <li style={styles.li}>
            сведения о результате обработки звонка в CRM;
          </li>
          <li style={styles.li}>
            ссылки на записи звонков или метаданные записей, если такая функция
            используется;
          </li>
          <li style={styles.li}>
            служебные данные, необходимые для отображения событий в Bitrix24.
          </li>
        </ul>

        <h2 style={styles.h2}>3. Цели обработки данных</h2>
        <p style={styles.p}>
          Компания использует собранные данные исключительно для следующих
          целей:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            предоставление и поддержание работоспособности Приложения;
          </li>
          <li style={styles.li}>
            обеспечение функционала телефонии и интеграции с Bitrix24;
          </li>
          <li style={styles.li}>
            отображение истории звонков, событий и связанных записей в CRM;
          </li>
          <li style={styles.li}>
            аутентификация, авторизация и управление доступом;
          </li>
          <li style={styles.li}>
            обработка заявок в техническую поддержку;
          </li>
          <li style={styles.li}>
            устранение ошибок, диагностика и повышение стабильности работы
            сервиса;
          </li>
          <li style={styles.li}>
            обеспечение безопасности, предотвращение злоупотреблений и
            несанкционированного доступа;
          </li>
          <li style={styles.li}>
            выполнение требований законодательства и договорных обязательств.
          </li>
        </ul>

        <h2 style={styles.h2}>4. Правовые основания обработки данных</h2>
        <p style={styles.p}>
          Обработка данных может осуществляться на следующих основаниях:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            Ваше согласие на обработку данных;
          </li>
          <li style={styles.li}>
            необходимость исполнения договора или предоставления функционала
            Приложения;
          </li>
          <li style={styles.li}>
            соблюдение требований применимого законодательства;
          </li>
          <li style={styles.li}>
            законный интерес Компании в обеспечении безопасности,
            работоспособности и улучшении сервиса.
          </li>
        </ul>

        <h2 style={styles.h2}>5. Хранение данных</h2>
        <p style={styles.p}>
          Компания хранит данные только в течение срока, необходимого для
          достижения целей, указанных в настоящей Политике конфиденциальности,
          если более длительный срок хранения не требуется по закону или для
          исполнения обязательств.
        </p>
        <p style={styles.p}>
          Технические журналы, данные телефонии, CRM-события и иная служебная
          информация могут храниться в объёме, необходимом для поддержки работы
          Приложения, диагностики, безопасности и разрешения споров.
        </p>

        <h2 style={styles.h2}>6. Передача данных третьим лицам</h2>
        <p style={styles.p}>
          Компания не продаёт и не передаёт персональные данные Пользователей
          третьим лицам, за исключением следующих случаев:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            когда это необходимо для работы Приложения и интеграций;
          </li>
          <li style={styles.li}>
            когда данные передаются в Bitrix24 или иные подключённые сервисы по
            инициативе Пользователя;
          </li>
          <li style={styles.li}>
            когда передача требуется в соответствии с законом, судебным актом
            или обязательным запросом государственных органов;
          </li>
          <li style={styles.li}>
            когда передача необходима для защиты прав, имущества или безопасности
            Компании, Пользователей или третьих лиц;
          </li>
          <li style={styles.li}>
            когда передача осуществляется подрядчикам и техническим партнёрам,
            обеспечивающим хостинг, обработку данных, поддержку или безопасность,
            при условии соблюдения ими конфиденциальности.
          </li>
        </ul>

        <h2 style={styles.h2}>7. Сторонние сервисы</h2>
        <p style={styles.p}>
          Приложение может взаимодействовать со Сторонними сервисами, включая
          Bitrix24 и иные сервисы телефонии, аналитики, хранения данных и
          интеграций.
        </p>
        <p style={styles.p}>
          Компания не несёт ответственности за политику конфиденциальности,
          содержание и практику обработки данных такими Сторонними сервисами.
          Рекомендуем Вам самостоятельно ознакомиться с их правилами и условиями.
        </p>

        <h2 style={styles.h2}>8. Безопасность данных</h2>
        <p style={styles.p}>
          Компания принимает разумные организационные и технические меры для
          защиты данных от несанкционированного доступа, изменения, раскрытия,
          уничтожения или утраты.
        </p>
        <p style={styles.p}>
          Несмотря на это, ни один способ передачи данных через Интернет и ни
          один способ электронного хранения не может гарантировать абсолютную
          безопасность. Поэтому Компания не может гарантировать абсолютную
          защищённость данных.
        </p>

        <h2 style={styles.h2}>9. Права Пользователя</h2>
        <p style={styles.p}>В зависимости от применимого законодательства Вы можете:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            запросить доступ к своим персональным данным;
          </li>
          <li style={styles.li}>
            запросить исправление неточных или устаревших данных;
          </li>
          <li style={styles.li}>
            запросить удаление данных, если их хранение более не требуется;
          </li>
          <li style={styles.li}>
            отозвать согласие на обработку данных, если обработка основана на
            согласии;
          </li>
          <li style={styles.li}>
            запросить ограничение обработки данных в предусмотренных законом
            случаях;
          </li>
          <li style={styles.li}>
            обратиться в Компанию с вопросом о порядке обработки данных.
          </li>
        </ul>
        <p style={styles.p}>
          Для реализации этих прав Вы можете связаться с нами по контактам,
          указанным ниже.
        </p>

        <h2 style={styles.h2}>10. Конфиденциальность детей</h2>
        <p style={styles.p}>
          Приложение не предназначено для использования лицами младше 13 лет.
          Компания сознательно не собирает персональные данные детей. Если Вам
          стало известно, что ребёнок предоставил нам персональные данные,
          пожалуйста, свяжитесь с нами.
        </p>

        <h2 style={styles.h2}>11. Международная передача данных</h2>
        <p style={styles.p}>
          Ваши данные могут обрабатываться и храниться на серверах, расположенных
          за пределами страны Вашего нахождения, если это необходимо для работы
          Приложения, интеграций или инфраструктуры Компании.
        </p>
        <p style={styles.p}>
          Используя Приложение, Вы соглашаетесь с возможной передачей данных в
          такие юрисдикции при условии применения разумных мер защиты.
        </p>

        <h2 style={styles.h2}>12. Ссылки на сторонние сайты</h2>
        <p style={styles.p}>
          Приложение может содержать ссылки на сайты третьих лиц. Если Вы
          переходите по такой ссылке, Вы покидаете среду Приложения. Компания не
          контролирует и не несёт ответственности за содержание, политику
          конфиденциальности и практики любых сторонних сайтов и сервисов.
        </p>

        <h2 style={styles.h2}>13. Изменения в настоящей Политике</h2>
        <p style={styles.p}>
          Компания оставляет за собой право изменять настоящую Политику
          конфиденциальности в любое время. В случае существенных изменений
          обновлённая версия будет опубликована на этой странице.
        </p>
        <p style={styles.p}>
          Продолжение использования Приложения после вступления изменений в силу
          означает Ваше согласие с обновлённой редакцией Политики.
        </p>

        <h2 style={styles.h2}>14. Связаться с нами</h2>
        <p style={styles.p}>
          Если у Вас есть вопросы относительно настоящей Политики
          конфиденциальности, Вы можете связаться с нами:
        </p>

        <div style={styles.contactBox}>
          <p style={styles.contactItem}>
            <strong>Email:</strong> info@ats.am
          </p>
          <p style={styles.contactItem}>
            <strong>Сайт:</strong>{" "}
            <a
              href="https://it-spark.am/"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              https://it-spark.am/
            </a>
          </p>
          <p style={styles.contactItem}>
            <strong>Телефон:</strong> +37444720101
          </p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#f5f7fb",
    minHeight: "100vh",
    padding: "32px 16px",
  },
  container: {
    maxWidth: "960px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "32px",
    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
    fontFamily: "Arial, sans-serif",
    color: "#1f2937",
    lineHeight: 1.7,
  },
  h1: {
    fontSize: "30px",
    marginBottom: "8px",
    color: "#111827",
  },
  h2: {
    fontSize: "22px",
    marginTop: "30px",
    marginBottom: "12px",
    color: "#111827",
    borderBottom: "1px solid #e5e7eb",
    paddingBottom: "6px",
  },
  h3: {
    fontSize: "18px",
    marginTop: "20px",
    marginBottom: "10px",
    color: "#1f2937",
  },
  updated: {
    color: "#6b7280",
    fontSize: "14px",
    marginBottom: "20px",
  },
  p: {
    margin: "10px 0",
    fontSize: "16px",
  },
  ul: {
    margin: "10px 0 10px 22px",
    padding: 0,
  },
  li: {
    marginBottom: "8px",
    fontSize: "16px",
  },
  contactBox: {
    marginTop: "12px",
    padding: "18px",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
  },
  contactItem: {
    margin: "8px 0",
    fontSize: "16px",
  },
  link: {
    color: "#2563eb",
    textDecoration: "none",
  },
};